import Vue from 'vue'
import Router from 'vue-router'
import Search from './views/Search.vue'
import Results from './views/Results.vue'
import ApiChildHandler from './views/ApiChildHandler.vue'
import {StoreConfig} from './store/storeConfig'

Vue.use(Router)

export default new Router({
  mode: 'history',  
  routes: [
    {
      path: '/',
      name: 'Search',
      component: Search
    },
    {
      path: '/results',
      name: 'Results',
      component: Results
    },
    {
      path: StoreConfig.serverRoot + '/*',
      name: 'api-child-handler',
      component: ApiChildHandler
    }
  ]
})